import React from "react";
import Greeting from "../containers/greeting/Greeting";
import Skills from "../containers/skills/Skills";
import Education from "../containers/education/Education";
import "./Page.scss";

const Home = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <Greeting />
        <Skills />
        <Education />
      </div>
    </div>
  );
};

export default Home;

